import { ProgressBarPoint } from "common/contracts";

export function convertProgressBarPointsToApiFormat(
    progressBarPoints: { progressBarId?: string | null; progressBarPoints?: number | null } | null | undefined
): ProgressBarPoint[] | undefined {
    if (!progressBarPoints) {
        return undefined;
    }

    const { progressBarId, progressBarPoints: points } = progressBarPoints;

    if (progressBarId && points != null && points > 0) {
        return [{ points, barId: progressBarId }];
    }

    return undefined;
}
